import { render, staticRenderFns } from "./reqInfo.vue?vue&type=template&id=0f919d56&scoped=true&"
import script from "./reqInfo.vue?vue&type=script&lang=js&"
export * from "./reqInfo.vue?vue&type=script&lang=js&"
import style0 from "./reqInfo.vue?vue&type=style&index=0&id=0f919d56&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f919d56",
  null
  
)

export default component.exports